<template>
  <div>
    <div class="px-4 py-2 mb-3 text-red-700 bg-red-200 rounded-md" v-if="form_errors.length">
      <template v-for="error in form_errors">
        <div :key="error.message">
          {{ error.message }}
        </div>
      </template>
    </div>

    <form @submit.prevent="register()" :disabled="submitting">
      <fieldset class="form-group">
        <label for="name" class="form-label">Name</label>
        <input ref="initial" id="name" class="form-input" type="text" v-model="form.name" tabindex="1" placeholder="Your Name" required>
        <validations :errors="errors" field="name" />
      </fieldset>
      <fieldset class="form-group">
        <label for="company" class="form-label">
          Company
          <div class="ml-2 text-xs font-normal text-gray-500">Optional</div>
        </label>
        <input id="company" class="form-input" type="text" v-model="form.company" tabindex="1" placeholder="Your Company Name">
        <validations :errors="errors" field="company" />
      </fieldset>
      <fieldset class="form-group">
        <label for="email" class="form-label">Email Address</label>
        <input id="email" class="form-input" type="email" v-model="form.email" tabindex="1" placeholder="Your Email Address" required>
        <validations :errors="errors" field="email" />
      </fieldset>
      <fieldset class="form-group">
        <label for="phone" class="form-label">Phone Number</label>
        <CellphoneInput id="phone" placeholder="Your Phone Number" tabindex="1" v-model="form.phone" @input="handlePhoneInput" />
        <validations :errors="errors" field="country" />
        <validations :errors="errors" field="phone" />
      </fieldset>
      <fieldset class="form-group">
        <label for="password" class="items-center justify-between form-label">
          Password 
          <a class="text-xs font-normal tracking-wide uppercase text-accent hover:underline" href="#" @click="showPassword = !showPassword" tabindex="-1">
            {{ showPassword ? 'Hide' : 'Show' }} Password
          </a>
        </label>
        <input id="password" class="form-input" :type="showPassword ? 'text' : 'password'" placeholder="Create A Password" v-model="form.password" required>
        <validations :errors="errors" field="password" />
      </fieldset>
      <fieldset class="form-group">
        <label for="password_confirmation" class="form-label">
          Confirm Password
        </label>
        <input id="password_confirmation" type="password" class="form-input" v-model="form.password_confirmation" placeholder="Confirm Password">
        <validations :errors="errors" field="password_confirmation" />
      </fieldset>
      <button type="submit" class="w-full btn btn-accent" v-submitting="submitting">
        Register
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CellphoneInput from '@/components/CellphoneInput'

export default {
  name: 'CustomerRegister',

  components: {
    CellphoneInput
  },

  mounted () {
    this.$refs.initial.focus()
  },

  computed: {
    ...mapState(['portal'])
  },

  data () {
    return {
      success: false,
      submitting: false,
      showPassword: false,
      errors: [],
      form_errors: [],
      form: {
        name: '',
        company: '',
        phone: '',
        country: '',
        email: '',
        password: '',
        password_confirmation: ''
      }
    }
  },

  methods: {
    ...mapActions('customer', ['syncCustomer']),

    handlePhoneInput (number, country) {
      this.form.phone = number
      this.form.country = country.iso2
    },

    async register () {
      try {
        this.submitting = true
        const { data } = await this.$api.post(`portal/${this.portal.subdomain}/auth/customer/register`, this.form)
        this.$cookies.remove('token')
        this.$cookies.remove('customer_token')
        this.$cookies.set('customer_token', data.token.token, {
          secure: process.env.NODE_ENV === 'production' ? true : false,
          samesite: process.env.NODE_ENV === 'production' ? 'None' : 'Lax'
        })
        await this.syncCustomer()
        this.$router.push({ name: 'CustomerBookingList' })
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
        this.errors = error.response.data.errors ? error.response.data.errors : []
        this.form_errors = error.response.data.form_errors ? error.response.data.form_errors : []
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
